import { Controller } from "stimulus";
const { DateTime } = require("luxon");

export default class extends Controller {
  connect() {
    //this.loopTime();
    this.updateTime();
    setInterval(this.updateTime.bind(this), 1000);
  }

  updateTime() {
    var now = DateTime.local();
    this.element.textContent = now.toFormat("HH:mm:ss");
  }

  loopTime() {
    this.updateTime();
    setTimeout(this.loopTime, 1000);
  }
}
